import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ModalData } from '@models/entities/general';

@Component({
    selector: 'normal-modal',
    templateUrl: './normal-modal.html',
    standalone: false
})
export class NormalModalComponent {
  title = '';
  message = '';
  btnCancel = '';
  btnSave = '';

  constructor(
    public dialogRef: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA) public data: ModalData
  ) {
    this.title = data.title;
    this.message = data.message;
    this.btnCancel = data.btnCancel ?? '';
    this.btnSave = data.btnSave ?? '';
  }

  close(save = false): void {
    this.dialogRef.close(save);
  }
}
